export default "__VITE_ASSET__Bo$8hsey__"